import { Callout, Intent } from "@blueprintjs/core";
import { connect } from "react-redux";

import initialState from "core/reducers/initialState";
import StringUtil from "core/util/StringUtil";
import { iDef } from "core/util/TypeUtils";
import { ICondition, IConditionType } from "./IConditionType";


export const ConnectedConditionPreview = connect<{ result: boolean; }, any, { condition: ICondition; }>(
	(state: typeof initialState, ownProps) => {
	const ct = ConditionTypeRegistry.get(ownProps.condition.type);

	return {
		result: !!ct && ct.evaluate(ownProps.condition.data, state)
	};
})(({condition, result}: any) => {
	const ct = ConditionTypeRegistry.get(condition.type);

	return (
		<Callout intent={ct ? (result ? Intent.SUCCESS : Intent.DANGER) : Intent.NONE}>
			{
				ct ? (
					ct.type && ct.renderPreview && ct.renderPreview(condition.data || {}) || ct.label
				) : 'No Conditions Selected'
			}
		</Callout>
	);
});

export class ConditionTypeRegistry {

	private static registered: { [type: string]: IConditionType } = {};
	private static cache: { [uuid: string]: boolean; } = {};

	/**
	 * register a condition type
	 * @param conditionType
	 */
	public static register<T>(conditionType: IConditionType<T>): IConditionType<T> {
		if (this.registered[conditionType.type]) {
			throw new Error("Duplicate Condition Type ID");
		}
		this.registered[conditionType.type] = conditionType;
		return conditionType;
	}

	/**
	 * retrieve a condition type
	 * @param type
	 */
	public static get<T = any>(type: string): IConditionType<T> | undefined {
		return this.registered[type];
	}

	public static clearCache() {
		this.cache = {};
	}

	public static evaluate(condition: ICondition, state: typeof initialState): boolean {
		if (iDef(this.cache[condition.uuid])) {
			return this.cache[condition.uuid];
		}

		let val = false;

		iDef(this.get(condition.type), (ct) => {
			val = this.cache[condition.uuid] = ct.evaluate(condition.data, state);
		});

		return val;
	}

	public static preview(condition: ICondition): JSX.Element | string {
		return <ConnectedConditionPreview condition={condition} />;
	}

	public static create<T = any>(type: string): ICondition<T> {
		const ct = this.get(type);
		if (!ct) {
			throw new Error("Invalid Condition Type ID");
		}
		return {
			type,
			uuid: StringUtil.generateUuid(),
			data: !!ct.getInitialValue && ct.getInitialValue() || {}
		};
	}
}



// WEBPACK FOOTER //
// ./src/common/form/fields/condition/ConditionTypeRegistry.tsx